import { PaginatedResult, PaginationParams } from "./usePaginatedQuery";
import { asUtcDate, omitIfEmpty } from "../Utilities";
import { dateRangeFormat } from "../components/Common/Filters/DateRangePill";
import { HttpMethod } from "../components/Common/useFetch";
import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import OrderTransactionDto from "../components/Common/dtos/OrderTransactionDto";

export interface OrderTransactionPaginationParams extends PaginationParams {
  filterText?: string;
  itemId?: string;
  siteIds?: string[];
  startDate?: string;
  endDate?: string;
}

const useSearchOrderTransactions = (
  params: OrderTransactionPaginationParams,
  options?: QueryOptions<PaginatedResult<OrderTransactionDto>>
) => {
  const business = useSelectedBusiness();

  return useUserQuery<PaginatedResult<OrderTransactionDto>>({
    path: `/api/businesses/${business.id}/orderTransactions/search`,
    method: HttpMethod.POST,
    body: {
      ...params,
      filterText: omitIfEmpty(params.filterText),
      itemId: omitIfEmpty(params.itemId),
      startDate: asUtcDate(params.startDate, dateRangeFormat),
      endDate: asUtcDate(params.endDate, dateRangeFormat),
    },
  }, options);
};

export default useSearchOrderTransactions;